export default {"src":"/_next/static/media/icon-stats-critical-chance.3c71080b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};